<template>
    <b-card title="Administration">
        <Table/>
    </b-card>
</template>

<script>
import Table from './clientUsersTable.vue'
export default {
    data:() => ({}),
    components:{
        Table
    },
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>

</style>